import React, { PropsWithChildren } from 'react';
import FooterCopyright from './FooterCopyright';
import { Navbar, NavbarBrand } from 'reactstrap';
import { Link } from 'gatsby';
import { rootPath, toGetStarted, toSignIn } from '../../routes';
import AuthenticatedDropdownMenu from './AuthenticatedDropdownMenu';
import { GlobalContext } from '../../context/GlobalContext';
import LocalImage from '../common/images/LocalImage';

const CustomLayout = (props: PropsWithChildren<{ isLogin: boolean }>) => {
  const {
    userAuth: { isAuthenticated },
  } = React.useContext(GlobalContext);

  return (
    <>
      <Navbar>
        <NavbarBrand
          tag={Link}
          to={rootPath}
          style={{ height: '65px' }}
          className="d-flex align-items-center"
        >
          <LocalImage
            src="dentalpost-logo-on-light-bg.png"
            alt="DentalPost Logo"
            width={70}
            height={44}
            loading="eager"
          />
        </NavbarBrand>
        <div className="d-flex h-100 align-items-center flex-grow-1 justify-content-between">
          {isAuthenticated ? (
            <div className="ms-auto">
              <AuthenticatedDropdownMenu />
            </div>
          ) : props.isLogin ? (
            <p className="mb-0 d-flex flex-wrap flex-grow-1 gap-2 justify-content-end">
              New to DentalPost?{' '}
              <Link to={toGetStarted} className="ms-1">
                Create an Account
              </Link>
            </p>
          ) : (
            <p className="mb-0 d-flex flex-wrap flex-grow-1 gap-2 justify-content-end">
              Already have an account?{' '}
              <Link to={toSignIn} className="ms-1">
                Sign In
              </Link>
            </p>
          )}
        </div>
      </Navbar>
      <main className="flex-grow-1" role="main">
        {props.children}
      </main>
      <footer role="contentinfo">
        <FooterCopyright />
      </footer>
    </>
  );
};

export default CustomLayout;
